import { render, staticRenderFns } from "./ISFDetailHTS.vue?vue&type=template&id=424002fa&"
import script from "./ISFDetailHTS.vue?vue&type=script&lang=js&"
export * from "./ISFDetailHTS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports